import React from "react";
import { useDragLayer } from "react-dnd";

const layerStyles = {
	position: "fixed",
	pointerEvents: "none",
	zIndex: 100,
	left: 0,
	top: 0,
	width: "100%",
	height: "100%",
};

const dragItemStyles = {
	width: "300px",
	height: "30px",
	border: "1px dashed var(--color-primary)",
	borderRadius: "3px"
};

function getItemStyles (initialOffset, currentOffset) {
	if (!initialOffset || !currentOffset) {
		return {
			display: "none",
		};
	}
	let { x, y } = currentOffset;
	const transform = `translate(${x}px, ${y}px)`;

	return {
		transform,
		WebkitTransform: transform,
	};
}

export const DragLayer = props => {
	const {
		isDragging,
		item,
		initialOffset,
		currentOffset,
	} = useDragLayer(monitor => ({
		item: monitor.getItem(),
		initialOffset: monitor.getInitialSourceClientOffset(),
		currentOffset: monitor.getSourceClientOffset(),
		isDragging: monitor.isDragging(),
	}));

	function renderItem () {
		return (<div style={ dragItemStyles }>{item.item?.text}</div>);
	}

	if (!isDragging) {
		return null;
	}

	return (
		<div style={layerStyles}>
			<div
				style={getItemStyles(initialOffset, currentOffset)}
			>
				{renderItem()}
			</div>
		</div>
	);
};

export default DragLayer;
